/* global jQuery COMPONENTS google propertyLocations locationProperty googleMapsStyler */

COMPONENTS.ComponentMarketMap = (function ($) {
  function ComponentMarketMap () {
    // Component-global variable declarations
    this.$component = $('[data-ecs-component="component-marketmap"]')

    // Community View Switcher
    this.$cardsAndMap = this.$component.find('.ecs_marketmap_content_wrapper')
    this.$cardsAndMapButton = this.$component.find('[data-community-view="split"]')
    this.$cardsButton = this.$component.find('[data-community-view="cards"]')
    this.$mapButton = this.$component.find('[data-community-view="map"]')
    this.$cards = this.$component.find('.ecs_marketmap_property_cards')
    this.$card = this.$component.find('.ecs_marketmap_card_wrapper')

    // Isotope / Filtering
    this.$grid = this.$component.find('[data-ecs-components-control="card-grid"]')
    this.$galleryItems = this.$component.find('[data-ecs-components-control="market-property"]')
    this.$linkedFilters = this.$component.find('[data-ecs-filter-link]')
    this.$firstFilter = '*'

    this.gridOpts = {
      itemSelector: '[data-ecs-components-control="property-card"]',
      layoutMode: 'fitRows',
      filter: this.$firstFilter
    }

    // Google Map
    this.$map = this.$component.find('[data-ecs-components-element="map"]')
    this.mapElem = this.$map.get(0)
    this.$cardsGrid = $('[data-ecs-components-control="card-grid"]')
    this.$propertyCards = $('[data-ecs-components-control="property-card"]')
    this.$filterSelect = $('[data-ecs-components-property-filter="select"]')
    this.$filterButtons = $('[data-ecs-components-property-filter="buttons"]').children()
    this.$filters = $('[data-ecs-components-property-filter]')

    if (typeof component_marketmap_properties === 'undefined') {
      return
    }

    // Grab the properties from the twig-passed JSON object
    this.propertyLocations = component_marketmap_properties
    // Set the filteredProperties at load to the full set of properties
    // Retain the original propertyLocations for reprocessing
    this.filteredProperties = []

    this.map = null
    this.markers = []
    this.bounds = new google.maps.LatLngBounds()

    this.mapArgs = {
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: false,
      cameraControl: true,
      streetViewControl: true,
      gestureHandling: 'cooperative'
    }

    if (typeof googleMapsStyler !== 'undefined') {
      this.mapArgs.styles = googleMapsStyler
    }
  }

  ComponentMarketMap.prototype.init = function () {
    const component = this
    const viewportLaptop = window.matchMedia('(min-width: 1024px)')
    let $params = new URLSearchParams(window.location.search)
    let $market = $params.get('market')

    component.setFilters()
    component.$grid.imagesLoaded(function () {
      component.doFilter()
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (250ms) to resolve, for now
      setTimeout(function () {
        component.calcCardHeights(component.$grid)
      }, 400)
    })

    if ($market) {
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (50ms) to resolve, for now
      setTimeout(function () {
        component.paramFilter($market)
      }, 50)
    }

    this.initMap()
    component.bindViews()
    this.bindFilters()
    this.bindLinkedFilters()
    this.bindCards()

    $(window).on('resize orientationchange', function () {
      if (!viewportLaptop.matches) {
        component.$cardsButton.click()
        component.resizeMap()
        component.calcCardHeights(component.$grid)
      } else {
        component.$cardsAndMapButton.click()
        component.resizeMap()
      }
    })
  }

  ComponentMarketMap.prototype.calcCardHeights = function (grid) {
    const $blogItems = $(grid).find('[data-ecs-components-control="property-card"]')
    let tallestCardHeight = 0
    const viewportTablet = $(window).width() >= 769

    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs_marketmap_card')
      cardWrap.css('min-height', '')
    })

    // Loop over the article cards to find the card with the greatest height
    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs_marketmap_card')
      tallestCardHeight = Math.max(tallestCardHeight, cardWrap.outerHeight())
    })

    // Test if viewport is tablet or greater
    if (viewportTablet) { // Tablet or above
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs_marketmap_card')
        cardWrap.css('min-height', (tallestCardHeight + 'px'))
      })
    } else { // Mobile
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs_marketmap_card')
        cardWrap.css('min-height', '')
      })
    }

    $(grid).isotope('layout')
  }

  ComponentMarketMap.prototype.paramFilter = function ($market) {
    // clicks the button with the parameter from URL
    if ($market) $('[data-ecs-components-market-filter="' + $market + '"]').click()
  }

  ComponentMarketMap.prototype.setURL = function (button) {
    // if a filter is clicked, update URL parameters
    if (button) {
      let currentUrl = window.location.href
      let url = new URL(currentUrl)
      url.searchParams.set('market', button.data('ecs-components-market-filter')) // set the clicked parameter
      let newUrl = url.href
      window.history.replaceState(null,'',newUrl)
    }
  }

  ComponentMarketMap.prototype.compileFilters = function () {
    const component = this
    let filterValues = []

    function removeDuplicates (data) {
      return data.filter((value, index) => data.indexOf(value) === index)
    }

    component.$filters.each(function () {
      // This filter is a collection of buttons, get the active button to pass
      if ($(this).attr('data-ecs-components-property-filter') === 'buttons') {
        const $activeSearch = $(this).children('[data-ecs-filter-active]')
        let activeButtons = []
        $activeSearch.each(function () {
          activeButtons = [...activeButtons, $(this).attr('data-ecs-components-market-filter')]
        })
        filterValues = [...filterValues, ...activeButtons]
      }

      // This filter is a select filter
      if ($(this).attr('data-ecs-components-property-filter') === 'select') {
        filterValues = [...filterValues, $(this).find(':selected').val()]
      }
    })

    // Parse to remove unnecessary duplicate filter values, return
    return removeDuplicates(filterValues)
  }

  ComponentMarketMap.prototype.buildIsotopeFilter = function (_filterValues) {
    const component = this
    let filterValues = _filterValues

    function containsOnly (array1, array2) {
      return array2.every(elem => array1.includes(elem))
    }

    // If filterValues contains only '*', filters are all inactive
    // Pass * as filter value (include all elements)
    if (containsOnly(['*'], filterValues)) {
      component.gridOpts.filter = '*'
    } else {
      // At least one filter has a value, remove * values and join as string
      filterValues = filterValues.filter((value) => value !== '*')
      component.gridOpts.filter = '.' + filterValues.join('.')
    }
  }

  ComponentMarketMap.prototype.filterMarkers = function (_filters) {
    const filterNone = JSON.stringify(['*'])
    const filterString = JSON.stringify(_filters)
    const component = this

    // Reset the filteredProperties so we can rebuild with matching pins
    if (filterString === filterNone) {
      component.filteredProperties = component.propertyLocations
      return
    } else {
      component.filteredProperties = []
    }

    // Loop over the original propertyLocations
    for (let i = 0; i < component.propertyLocations.length; i++) {
      let filtersMatch = true

      // Loop over the _filters, test if each is present in the property filters
      _filters.forEach(function (filter) {
        if (filter === '*') {
          return
        }

        if (!component.propertyLocations[i].filters.includes(filter)) {
          filtersMatch = false
        }
      })

      // If all filters match the property, push property to filteredProperties
      if (filtersMatch) {
        component.filteredProperties.push(component.propertyLocations[i])
      }
    }
  }

  ComponentMarketMap.prototype.setFilters = function () {
    const component = this
    component.buildIsotopeFilter(component.compileFilters())
    component.filterMarkers(component.compileFilters())
  }

  ComponentMarketMap.prototype.doFilter = function (button) {
    const component = this

    // FIXME: added a timeout to prevent a race condition revolving around
    // linkedFilters binding adding erroneous filters during compileFilters()
    setTimeout(() => {
      component.clearMarkers()

      component.setURL(button)
      component.setFilters()
      component.addMarkers(component.filteredProperties)
      component.$grid.isotope(component.gridOpts)
    }, 400)
  }

  ComponentMarketMap.prototype.initMap = function () {
    const component = this
    component.map = new google.maps.Map(this.mapElem, this.mapArgs)
  }

  ComponentMarketMap.prototype.resizeMap = function () {
    const component = this
    google.maps.event.trigger(component.map, 'resize')
  }

  ComponentMarketMap.prototype.bindViews = function () {
    const component = this
    // cards and map split view
    component.$cardsAndMapButton.click(function () {
      component.$cardsAndMap.removeClass('map-only')
      component.$cardsAndMap.removeClass('cards-only')

      // Sets cards to two columns at tablet
      component.$card.addClass('is-half-tablet')
      component.$card.removeClass('is-one-quarter-tablet')
      component.$cards.addClass('is-2-tablet')
      component.$cards.removeClass('is-4-tablet')

      // Remove active class on map or split
      component.$cardsButton.removeClass('ecs_active')
      component.$mapButton.removeClass('ecs_active')
      component.$cardsAndMapButton.addClass('ecs_active')

      // Trigger isotope grid resort to take up the expanded space
      component.$grid.isotope(component.gridOpts)
      component.resizeMap()
    })

    // cards only view
    component.$cardsButton.click(function () {
      component.$cardsAndMap.removeClass('map-only')
      component.$cardsAndMap.addClass('cards-only')

      // Sets cards to four columns at tablet
      component.$card.removeClass('is-half-tablet')
      component.$card.addClass('is-one-quarter-tablet')
      component.$cards.removeClass('is-2-tablet')
      component.$cards.addClass('is-4-tablet')

      // Remove active class on map or split
      component.$cardsAndMapButton.removeClass('ecs_active')
      component.$mapButton.removeClass('ecs_active')
      component.$cardsButton.addClass('ecs_active')

      // Trigger isotope grid resort to take up the expanded space
      component.$grid.isotope(component.gridOpts)
    })

    // map only view
    component.$mapButton.click(function () {
      component.$cardsAndMap.addClass('map-only')
      component.$cardsAndMap.removeClass('cards-only')

      // Remove active class on map or split
      component.$cardsAndMapButton.removeClass('ecs_active')
      component.$cardsButton.removeClass('ecs_active')
      component.$mapButton.addClass('ecs_active')

      component.resizeMap()
    })
  }

  ComponentMarketMap.prototype.bindFilters = function () {
    const component = this
    component.bindFilterSelect()
    component.bindFilterButtons()
  }

  ComponentMarketMap.prototype.bindFilterSelect = function () {
    const component = this
    component.$filterSelect.change(function () {
      component.doFilter()
    })
  }

  ComponentMarketMap.prototype.bindFilterButtons = function () {
    const component = this

    component.$filterButtons.each(function () {
      const $button = $(this)
      const $parent = $button.parent()
      const $siblings = $parent.children()

      $button.click(function () {
        $siblings.each(function () {
          $(this).removeClass('ecs_active')
          $(this).removeAttr('data-ecs-filter-active')
        })

        $button.attr('data-ecs-filter-active', true)

        $($button).addClass('ecs_active')
        component.doFilter($button)
      })
    })
  }

  ComponentMarketMap.prototype.bindLinkedFilters = function () {
    const component = this

    component.$linkedFilters.each(function () {
      const $filter = $(this)

      // Filter is a set of Buttons, update linked Select to match changes
      if ($filter.attr('data-ecs-filter-element') === 'button') {
        $filter.click(function () {
          const linkCategory = $filter.attr('data-ecs-filter-link')
          const activeValue = $filter.attr('data-ecs-components-market-filter')
          const $linkedSelect = $('[data-ecs-filter-link="' + linkCategory + '"][data-ecs-filter-element="select"]')

          $linkedSelect.val(activeValue)
          $('.nice-select').niceSelect('update')
        })
      }

      // Filter is a dropdown Select
      if ($filter.attr('data-ecs-filter-element') === 'select') {
        const linkCategory = $filter.attr('data-ecs-filter-link')

        $filter.on('change', function () {
          const activeValue = $filter.find(':selected').val()
          const $linkedButtons = $('[data-ecs-filter-link="' + linkCategory + '"][data-ecs-filter-element="button"]')

          $linkedButtons.each(function () {
            $(this).removeAttr('data-ecs-filter-active')
            $(this).removeClass('ecs_active')

            if ($(this).attr('data-ecs-components-market-filter') === activeValue) {
              $(this).attr('data-ecs-filter-active', true)
              $(this).addClass('ecs_active')
            }
          })
        })
      }
    })
  }

  ComponentMarketMap.prototype.bindCards = function () {
    const component = this

    this.$propertyCards.each(function () {
      const $card = $(this)

      $card.click(function () {
        const id = $(this).data('ecs-components-property-id')
        component.removeActive()
        $card.addClass('ecs_active')
        component.clearMarkers()
        component.addMarkers(component.filteredProperties, id)
      })
    })
  }

  ComponentMarketMap.prototype.bindMarker = function (_marker) {
    const component = this
    const selector = `[data-ecs-components-property-id="${_marker.property}"]`
    const $listItem = $(selector)
    const position = Math.abs($listItem.position().top) - 72

    google.maps.event.addListener(_marker, 'click', function () {
      component.$cardsGrid.parent().animate({ scrollTop: position }, 750)

      component.$propertyCards.each(function () {
        $(this).removeClass('ecs_active')
      })

      $listItem.addClass('ecs_active')

      for (let i = 0; i < component.markers.length; i++) {
        if (component.markers[i].infoWindow) {
          component.markers[i].infoWindow.close()
        }
      }

      _marker.infoWindow.open({
        anchor: _marker,
        map: component.map,
        shouldFocus: false
      })

      component.clearMarkers()
      component.addMarkers(component.filteredProperties, $(this)[0].property)
    })
  }

  ComponentMarketMap.prototype.removeActive = function () {
    const component = this

    component.$propertyCards.each(function () {
      $(this).removeClass('ecs_active')
    })
  }

  ComponentMarketMap.prototype.generateMarkerIcon = function (_url, _size = null, _type, _anchor = null) {
    let icon = {}
    if (_type === 'svg') {
      icon.url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(_url)
      if (_anchor != null) {
        icon.anchor = new google.maps.Point(0, 40)
      }
      if (_size != null) {
        icon.scaledSize = new google.maps.Size(_size, _size)
      }
    } else {
      icon.icon = _url
    }

    return icon
  }

  ComponentMarketMap.prototype.addMarkers = function (_properties, _highlightID = 0) {
    const component = this
    this.bounds = new google.maps.LatLngBounds()

    const filteredProperties = _properties

    for (let i = 0; i < filteredProperties.length; i++) {
      let markerItem = {}
      markerItem.title = filteredProperties[i].name
      markerItem.map = this.map
      markerItem.property = filteredProperties[i].id
      markerItem.markerIcon = markerItem.markerIcon = component.generateMarkerIcon(filteredProperties[i].marker.default.src_uri, 47, filteredProperties[i].marker.default.type)

      if (_highlightID === markerItem.property && filteredProperties[i].marker_active !== false) {
        markerItem.markerIcon = component.generateMarkerIcon(filteredProperties[i].marker.active.src_uri, 47, filteredProperties[i].marker.active.type)
      }

      if (filteredProperties[i].override_latitude_coordinates && filteredProperties[i].override_longitude_coordinates) {
        markerItem.propertyLatLng = { lat: parseFloat(filteredProperties[i].override_latitude_coordinates), lng: parseFloat(filteredProperties[i].override_longitude_coordinates) }
      } else {
        const propertyLatLng = new google.maps.LatLng(filteredProperties[i].location.lat, filteredProperties[i].location.lng)
        markerItem.propertyLatLng = propertyLatLng
      }

      let marker = new google.maps.Marker({
        position: markerItem.propertyLatLng,
        title: 'Marker icon for ' + filteredProperties[i].name,
        map: markerItem.map,
        icon: markerItem.markerIcon,
        defaultIcon: filteredProperties[i].marker.default,
        activeIcon: filteredProperties[i].marker.active,
        property: markerItem.property,
        animation: google.maps.Animation.DROP
      })

      const infoWindowData = {}
      if (typeof markerItem.title != 'undefined') {
        infoWindowData.title = '<p class="ecs_propertyname">' + markerItem.title + '</p>'
      } else { infoWindowData.title = '' }

      if (typeof filteredProperties[i].bed_counts_string != 'undefined') {
        infoWindowData.bedCount = '<p class="ecs_bedcounts">' + filteredProperties[i].bed_counts_string + '</p>'
      } else { infoWindowData.bedCount = '' }

      if (typeof filteredProperties[i].location != 'undefined') {
        infoWindowData.address = `<p class="ecs_address">
          <a class="ecs_a" href="${filteredProperties[i].place_link}" target="_blank">${filteredProperties[i].location.two_line_string ? filteredProperties[i].location.two_line_string : filteredProperties[i].location.address_string}</a>
        </p>`
      } else { infoWindowData.address = '' }

      if (typeof filteredProperties[i].phone != 'undefined') {
        infoWindowData.phone = '<a class="ecs_a" href="tel:' + filteredProperties[i].phone + '">' + filteredProperties[i].phone + '</p>'
      } else { infoWindowData.phone = '' }

      const contentString = `<div class="ecs_infowindow">
        <div class="ecs_image">
          <picture class="ecs_picture">
            <source src="${filteredProperties[i].image}">
            <img class="ecs_img" src="${filteredProperties[i].image}">
          </picture>
        </div>
        <div class="ecs_propertyinfo">
          ${infoWindowData.title}
          ${infoWindowData.bedCount}
          ${infoWindowData.address}
          ${infoWindowData.phone}
        </div>
        <div class="ecs_propertylinks">
          <p class="ecs_propertylink">
            <a class="ecs_btn ecs_button" href="${filteredProperties[i].link}" target="_blank">View Property</a>
          </p>
        </div>
      </div>`

      marker.infoWindow = new google.maps.InfoWindow({ content: contentString })

      this.bounds.extend(marker.position)
      this.markers.push(marker)
      this.bindMarker(marker)
    }

    if (_highlightID > 0) {
      const highlight = this.markers.filter(function (marker) {
        return marker.property === _highlightID
      })

      this.map.setZoom(18)
      this.map.panTo(highlight[0].position)

      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].infoWindow) {
          this.markers[i].infoWindow.close()
        }
      }

      highlight[0].infoWindow.open({
        anchor: highlight[0],
        map: this.map,
        shouldFocus: false
      })
    } else {
      this.map.fitBounds(this.bounds)
    }
  }

  ComponentMarketMap.prototype.clearMarkers = function () {
    for (let m = 0; m < this.markers.length; m++) {
      this.markers[m].setMap(null)
    }
    this.markers = []
  }

  return ComponentMarketMap
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init

  if (pageComponentsList.includes('component-marketmap')) {
    COMPONENTS.ComponentMarketMap = new COMPONENTS.ComponentMarketMap()
    COMPONENTS.ComponentMarketMap.init()
  }
})
